<nav #navbar class="navbar" [ngClass]="isNavbarShow ? 'active' : 'inactive'">
    <div class="container-fluid">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed" (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>

            <!-- mobile menu bars -->
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand" routerLink="dashboard">
                <div class="logo-full logo-light">
                    <img src="assets/custom-images/logo_light.png" alt="" />
                </div>
                <div class="logo-full logo-dark">
                    <img src="assets/custom-images/logo_dark.png" alt="" />
                </div>
                <div class="logo-small logo-light">
                    <img src="assets/custom-images/logo-small_light.png" alt="" />
                </div>
                <div class="logo-small logo-dark">
                    <img src="assets/custom-images/logo-small_dark.png" alt="" />
                </div>
            </a>

        </div>
        <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
            <ul class="pull-left collapse-menu-icon">
                <li class="menuBtn">
                    <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons">
                        <app-feather-icons [icon]="'menu'" [class]="'header-icon'"></app-feather-icons>
                    </button>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <!-- Full Screen Button -->
                <li class="fullscreen">
                    <button mat-icon-button class="nav-notification-icons" (click)="callFullscreen()">
                        <app-feather-icons [icon]="'maximize'" [class]="'header-icon'"></app-feather-icons>
                    </button>
                </li>
                <!-- #END# Full Screen Button -->
                @if(isLanguageSelectorVisible){
                    <li class="languageMenu">
                        <ng-container [ngTemplateOutlet]="languageSelector"></ng-container>
                    </li>
                }

                <!-- #START# Notifications-->
                <li class="nav-item btnNotification" ngbDropdown>
                    @if(isOriginalNotificationVisible){
                        <ng-container [ngTemplateOutlet]="originalNotification"></ng-container>
                    }

                    <!-- custom notification -->
                    <app-header-notification></app-header-notification>
                </li>

                <!-- #END# Notifications-->
                <li class="nav-item user_profile">
                    <button mat-button [matMenuTriggerFor]="profilemenu">
                        <div class="chip dropdown-toggle" ngbDropdownToggle class="">

                            <div class="user-photo">
                                <app-user-photo></app-user-photo>
                            </div>

                        </div>
                    </button>
                    <mat-menu #profilemenu="matMenu" class="profile-menu">
                        <div class="noti-list">
                            <div class="menu ">
                                <div class="user_dw_menu">
                                    <button mat-menu-item class="user-item-list" routerLink="profile">
                                        <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>{{'header.profile.menu.profile' | translate}}
                                    </button>

                                    <button mat-menu-item (click)="logout()" class="user-item-list">
                                        <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>{{'header.profile.menu.logout' | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-menu>
                </li>
                <!-- #END# Tasks -->
            </ul>
        </div>
    </div>
</nav>

<ng-template #languageSelector>
    <button mat-icon-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons">
        @if (flagvalue !== undefined) {
            <img src="{{flagvalue}}" height="16" alt="{{'header.language.selector.default' | translate}}">
        }
        @else {
            <img src="{{defaultFlag}}" height="16" alt="{{'header.language.selector.default' | translate}}">
        }

    </button>
    <mat-menu #languagemenu="matMenu" class="lang-item-menu">
        @for (item of listLang; track item) {
            <div class="lang-item">
                <button mat-menu-item class="dropdown-item lang-item-list" (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': langStoreValue === item.lang}">
                    <img src="{{item.flag}}" class="flag-img" height="12" alt="{{('header.language.selector.' + item.lang) | translate}}">
                    <span class="align-middle">{{item.text | translate}}</span>
                </button>
            </div>
        }
    </mat-menu>
</ng-template>

<ng-template #originalNotification>
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons">
        <app-feather-icons [icon]="'bell'" [class]="'header-icon'"></app-feather-icons>
        <span class="label-count bg-orange"></span>
    </button>
    <mat-menu #notificationMenu="matMenu" class="nfc-menu">
        <div class="nfc-header">
            <h5 class="mb-0">Notitications</h5>
            <a class="nfc-mark-as-read">Mark all as read</a>
        </div>
        <div class="nfc-dropdown">
            <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                    <div class="menu">
                        <div>
                            @for (notification of notifications; track notification) {
                                <button mat-menu-item onClick="return false;" [ngClass]="[notification.status]">
                                    <span class="table-img msg-user ">
                                        <em class="material-icons-outlined nfc-type-icon" [ngClass]="[notification.color]">{{notification.icon}}</em>
                                    </span>
                                    <span class="menu-info">
                                        <span class="menu-title">{{notification.message}}</span>
                                        <span class="menu-desc mt-2">
                                            <em class="material-icons">access_time</em> {{notification.time}}
                                        </span>
                                    </span>
                                    <span class="nfc-close">
                                        <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons>
                                    </span>
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </ng-scrollbar>
        </div>
        <div class="nfc-footer">
            <a class="nfc-read-all">Read All Notifications</a>
        </div>
    </mat-menu>
</ng-template>
